module.exports = __webpack_public_path__ + "static/media/bann2.b5fb01d1.png";